import { useFocusEffect } from "@react-navigation/native";
import { useCallback } from "react";
import { useTheme } from "styled-components/native";

export const useAutoEnterKeySubmit = (
  onSubmit: () => void,
  isButtonDisabled = false
) => {
  const theme = useTheme();

  const onFocusEffect = useCallback(() => {
    if (!theme.isLargeScreen || typeof document === "undefined") {
      return undefined;
    }

    const handleKeyPress = (e: KeyboardEvent) => {
      if ((e.key === "Enter" || e.code === "Enter") && !isButtonDisabled) {
        e.preventDefault();
        onSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyPress, true);

    return () => {
      document.removeEventListener("keydown", handleKeyPress, true);
    };
  }, [theme.isLargeScreen, isButtonDisabled, onSubmit]);

  useFocusEffect(onFocusEffect);
};
